// Stats chart components read app-level window globals that the live stats page
// provides via Rails js_variables (see StatsController). The headless render-shell
// is not that page, so we stub the globals our mounted components touch — just
// enough to not crash. These feed table/legend/menu icons that never appear in the
// exported chart SVG, so empty values are fine. Add globals here as new charts
// surface them (must load before any component mounts — imported first in index.tsx).

const w = window as any

// qType → icon-font-name map. Live: window.icon_question_types = IconQuestionTypes.
// Read by vk/lib/utils, ChartButtons, components/lib/utils, sidebar panels, etc.
w.icon_question_types = w.icon_question_types || {}

// Force ChartContainer (components/charts/Chart) to mount charts eagerly instead of
// lazily on scroll-into-view (onVisible). Headless has no real viewport scroll, and
// multi-output charts render off-screen — they must all mount immediately. This is
// the React equivalent of legacy download.coffee's window.$onVisible.renderRequired().
w.$FullChartsLoading = true

// ShelfChart (sh) gates its whole image pipeline on this Rails js_variable
// (stats/index.html.erb sets it to the survey preview URL). The React code only
// checks truthiness — the value itself is never consumed — so any string unblocks it.
w.preview_token_path = w.preview_token_path || '/headless'
